import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
// One per component per line, so 200 lines of 25 components each still fits.
export const MAX_COMPONENT_EXTRAS = 5000;
/** Extra set aside at release on top of what the recipe needs, per line and component part. */
export const componentExtrasSchema = z
    .array(z.object({
    manufacturingOrderItemId: requiredUuidString('Each extra must name a part line.', 'Invalid part line on an extra.'),
    partId: requiredUuidString('Each extra must name a component.', 'Invalid component on an extra.'),
    qty: z
        .number({ error: 'An extra must be a number.' })
        .min(0, 'An extra cannot be negative.')
        .max(1_000_000_000, 'An extra is at most 1,000,000,000.'),
}))
    .max(MAX_COMPONENT_EXTRAS, `A release can carry at most ${MAX_COMPONENT_EXTRAS} extras.`)
    .refine((extras) => new Set(extras.map((extra) => `${extra.manufacturingOrderItemId}:${extra.partId}`)).size ===
    extras.length, 'Each component can have only one extra per line.');
//# sourceMappingURL=component-extras.js.map